import { TextField } from '@mui/material'

interface RequiredTextFieldProps {
  value: any
  label: string
  onChange: any
}

export const RequiredTextField = ({ value, onChange, label }: RequiredTextFieldProps) => {
  return (
    <TextField
      required
      error={!value.name}
      variant="outlined"
      style={{ width: '100%' }}
      label={label}
      value={value.name}
      onChange={e => {
        onChange({ ...value, name: e.target.value })
      }}
    />
  )
}
